import React, { useEffect } from 'react';
import OffdaysReportDataTable from './OffdaysReport';

const OffdaysReportIndex = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <OffdaysReportDataTable />
    </>
  );
};

export default OffdaysReportIndex;
